import React, { PureComponent, Fragment, createRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import NavbarComp from '../components/NavbarComp';
import FooterComp from '../components/FooterComp';
import { Container, Row, Col, Form, Button } from 'react-bootstrap'
import PageTooltip from "../components/Tooltip"
import PinField from "react-pin-field";
import { handleResetPin, pageErrors, handleChangePin, redirectPage } from '../hooks/auth'
import { useNavigate } from 'react-router-dom'

const mapStateToProps = (state) => {
  return {
    auth: state.auth
  }
}

const mapDispatchToProps = dispatch => ({
  handleResetPin: (data) => dispatch(handleResetPin(data)),
  handleChangePin: (data) => dispatch(handleChangePin(data)),
  pageErrors: () => dispatch(pageErrors()),
    redirectPage: () => dispatch(redirectPage())
});


const getValidate = (state) => {
  var new_pin = null
  var confirm_new_pin = null
  var valid = true

  if (state.new_pin == null || state.new_pin == "" || state.new_pin.length < 4) {
    new_pin = "Required"
    valid = false
  }

  if (state.confirm_new_pin == null || state.confirm_new_pin == "") {
    confirm_new_pin = "Required"
    valid = false
  }

  const disallowedPins = ["0000", "1111", "2222", "3333", "4444", "5555", "6666", "7777", "8888", "9999", "1234", "4321"];
  if (disallowedPins.includes(state.new_pin)) {
    new_pin = "This PIN is too easy to guess. Please choose another."
    valid = false
    valid = false
  }

  if (valid && state.new_pin !== state.confirm_new_pin) {
    confirm_new_pin = "PIN number do not match"
    valid = false
  }

  return { data: { new_pin: new_pin, confirm_new_pin: confirm_new_pin }, valid }
}

const NavigateOnStateChange = ({ shouldNavigate, to }) => {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (shouldNavigate) {
      navigate(to);
    }
  }, [shouldNavigate, navigate, to]);

  return null;
}

class ResetPin extends PureComponent {

  constructor(props) {
    super(props);
    this.PinFieldRef = [createRef(), createRef()];
    this.state = {
      new_pin: null,
      confirm_new_pin: null,
      error: {
        new_pin: null,
        confirm_new_pin: null
      },
      shouldNavigate: false,
      path: null
    };
    this.props.redirectPage()
  }

  componentDidUpdate() {
    if (this.props.auth.error_page === "resetpin") {
      this.props.pageErrors()
      this.errorUpdate(this.props.auth.errors)
    }
    if (this.props.auth.redirect_page === "pin updated") {
      var page_url = this.props.auth.access_token !== null ? "/dashboard" : "/login"
      this.setState({
        shouldNavigate: true,
        path: page_url
      })
    }
  }

  handlePinvalue = (value, name) => {
    this.setState({
      [name]: value,
      error: {
        ...this.state.error,
        [name]: null
      }
    })
  }

  handleResetPin = () => {
    const { token } = this.props
    if (getValidate(this.state).valid) {
      if (token !== undefined) {
        this.props.handleResetPin({
          old_pin: token,
          new_pin: this.state.new_pin,
          confirm_new_pin: this.state.confirm_new_pin
        })
      }
      if (this.props.auth.access_token !== null) {
        this.props.handleChangePin({
          new_pin: this.state.new_pin,
          confirm_new_pin: this.state.confirm_new_pin
        })
      }
    } else {
      this.setState({ error: getValidate(this.state).data })
    }
  }


  customizeInputs = (inputElements) => {
    if (inputElements) {
      inputElements.forEach((input) => {
        if (input && !input.placeholder) {
          input.placeholder = "*";
          input.type = "password";
          input.inputMode = "numeric";
        }
      });
    }
  }

  handleClearBackspace = (value, pinIndex) => {
    if (value === "" && this.PinFieldRef[pinIndex].current[0]) {
      this.PinFieldRef[pinIndex].current[3].focus();
    }
  }

  render() {
    return <Fragment>

      <NavbarComp />
      <div className="page-sections">
        <div className='reset-pin-wrap'>
          <Container>
            <div className='reset-pin-contents'>
              <h2 className='main-title-style'>RESET LOGIN</h2>
              {/* <p>Marc</p>
              <p>Peter</p>
              <p>marc.peter@gmail.com</p> */}
              <Row>
                <Col lg={12} md={12}>
                  <Form.Group className="mb-4 mt-4" controlId="formGroupPin">
                    <PageTooltip
                      title="New Login PIN number"
                      text="Please now enter a 4 digit PIN, so we can make sure your login details are unique but also quick and easy to use every day. You cannot enter consecutive numbers such as 0000 or 5555 along with other easy to guess numbers like 1234."
                      error={this.state.error.new_pin !== null}
                      error_text={this.state.error.new_pin}
                    />
                    <div className="pin-wrapper">
                      <span className='pin-class-dash-1'></span>
                      <span className='pin-class-dash-2'></span>
                      <PinField
                        autoComplete="new-password"
                        length={4}
                        onChange={(value) => this.handlePinvalue(value, "new_pin")}
                        onComplete={() => {
                          if (this.PinFieldRef[1].current && this.PinFieldRef[1].current[0]) {
                            this.PinFieldRef[1].current[0].focus();
                          }
                        }}
                        validate={["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]}
                        ref={(inputElements) => {
                          this.PinFieldRef[0].current = inputElements;
                          this.customizeInputs(inputElements);
                        }}
                      />
                    </div>
                  </Form.Group>
                </Col>
                <Col lg={12} md={12}>
                  <Form.Group className="mb-1" controlId="formGroupConfirmPin">
                    <Form.Label>Confirm new PIN number{this.state.error.confirm_new_pin !== null ? <span className="error-span">* {this.state.error.confirm_new_pin}</span> : null}</Form.Label>
                    <div className="pin-wrapper">
                      <span className='pin-class-dash-1'></span>
                      <span className='pin-class-dash-2'></span>
                      <PinField
                        autoComplete="confirm-password"
                        length={4}
                        onChange={(value) => {
                          this.handlePinvalue(value, "confirm_new_pin")
                          this.handleClearBackspace(value, 0);
                        }}
                        validate={["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]}
                        ref={(inputElements) => {
                          this.PinFieldRef[1].current = inputElements;
                          this.customizeInputs(inputElements);
                        }}
                      />
                    </div>
                  </Form.Group>
                </Col>
                <Col lg={12}>
                  <div className='form-submit-btn'>
                    <Button onClick={this.handleResetPin} type="submit">CONFIRM</Button>
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </div>
      </div>
      <FooterComp />

      <NavigateOnStateChange shouldNavigate={this.state.shouldNavigate} to={this.state.path} />
    </Fragment>
  }
}

ResetPin.propTypes = {
  classes: PropTypes.object.isRequired,
  token: PropTypes.string.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(ResetPin);
